import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_boat.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_o_truck-booking-black.svg'
import _imports_2 from '@/app/ui/assets/svg/ics_o_plane-booking-black.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-1744804f")

_pushScopeId("data-v-1744804f")
const _hoisted_1 = { class: "cargo-table w-full mt-3" }
const _hoisted_2 = { class: "flex flex-col items-start" }
const _hoisted_3 = { class: "w-full flex flex-row items-center gap-x-1 break-all text-left" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  class: "w-5",
  alt: "Kapal"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  class: "w-5",
  alt: "Truk"
}
const _hoisted_6 = {
  key: 2,
  src: _imports_2,
  class: "w-5",
  alt: "Pesawat"
}
const _hoisted_7 = { key: 3 }
const _hoisted_8 = {
  key: 4,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1 whitespace-nowrap"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" DG ")
const _hoisted_10 = {
  key: 5,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" K ")
const _hoisted_12 = { class: "flex flex-row gap-1 mt-2" }
const _hoisted_13 = {
  key: 0,
  class: "bg-yellow-lp-200 px-2 rounded-xl text-14px text-yellow-lp-100 inline-flex"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "pt-0.5 pr-1" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "16",
    height: "17",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.0001 3.83325C7.07712 3.83325 6.17487 4.10695 5.40744 4.61973C4.64001 5.13251 4.04187 5.86134 3.68866 6.71406C3.33545 7.56678 3.24304 8.5051 3.4231 9.41034C3.60316 10.3156 4.04762 11.1471 4.70027 11.7998C5.35291 12.4524 6.18443 12.8969 7.08968 13.0769C7.99492 13.257 8.93323 13.1646 9.78595 12.8114C10.6387 12.4581 11.3675 11.86 11.8803 11.0926C12.3931 10.3252 12.6668 9.4229 12.6668 8.49992C12.6668 7.26224 12.1751 6.07526 11.2999 5.20009C10.4248 4.32492 9.23777 3.83325 8.0001 3.83325ZM7.33343 2.49992V2.53707C7.1649 2.55591 6.99679 2.58194 6.82956 2.61521C5.66567 2.84672 4.59657 3.41816 3.75746 4.25728C2.91834 5.09639 2.3469 6.16549 2.11539 7.32938C1.88388 8.49326 2.0027 9.69966 2.45682 10.796C2.91095 11.8924 3.67998 12.8294 4.66668 13.4887C5.65337 14.148 6.81341 14.4999 8.0001 14.4999C9.5914 14.4999 11.1175 13.8678 12.2427 12.7426C13.368 11.6173 14.0001 10.0912 14.0001 8.49992C14.0001 7.31323 13.6482 6.15319 12.9889 5.1665C12.3296 4.1798 11.3926 3.41077 10.2962 2.95664C9.77261 2.73977 9.22393 2.59936 8.66676 2.53707V2.49992C8.66676 2.32311 8.59653 2.15354 8.4715 2.02851C8.34648 1.90349 8.17691 1.83325 8.0001 1.83325C7.82329 1.83325 7.65372 1.90349 7.52869 2.02851C7.40367 2.15354 7.33343 2.32311 7.33343 2.49992ZM10.6668 9.49992H8.0001C7.82329 9.49992 7.65372 9.42968 7.52869 9.30466C7.40367 9.17963 7.33343 9.01006 7.33343 8.83325V5.83325C7.33343 5.65644 7.40367 5.48687 7.52869 5.36185C7.65372 5.23682 7.82329 5.16659 8.0001 5.16659C8.17691 5.16659 8.34648 5.23682 8.4715 5.36185C8.59653 5.48687 8.66676 5.65644 8.66676 5.83325V8.16659H10.6668C10.8436 8.16659 11.0131 8.23682 11.1382 8.36185C11.2632 8.48687 11.3334 8.65644 11.3334 8.83325C11.3334 9.01006 11.2632 9.17963 11.1382 9.30466C11.0131 9.42968 10.8436 9.49992 10.6668 9.49992ZM1.63343 5.05325C1.74079 5.12845 1.86903 5.16808 2.0001 5.16659C2.1099 5.16602 2.21787 5.13834 2.3144 5.086C2.41093 5.03366 2.49304 4.95829 2.55343 4.86659C2.83869 4.43149 3.20543 4.0557 3.63343 3.75992C3.77766 3.67313 3.88373 3.53499 3.93033 3.37324C3.97692 3.21149 3.96061 3.0381 3.88465 2.88788C3.8087 2.73766 3.67873 2.62173 3.52084 2.56337C3.36295 2.50501 3.18883 2.50854 3.03343 2.57325C2.39752 2.97184 1.85607 3.50418 1.44677 4.13325C1.35028 4.28023 1.31576 4.45937 1.35072 4.63168C1.38568 4.80398 1.48729 4.9555 1.63343 5.05325ZM14.0001 5.16659C13.8909 5.16675 13.7833 5.14009 13.6868 5.08894C13.5904 5.03779 13.5079 4.96373 13.4468 4.87325C13.1648 4.43369 12.7976 4.05511 12.3668 3.75992C12.2225 3.67313 12.1165 3.53499 12.0699 3.37324C12.0233 3.21149 12.0396 3.0381 12.1155 2.88788C12.1915 2.73766 12.3215 2.62173 12.4794 2.56337C12.6372 2.50501 12.8114 2.50854 12.9668 2.57325C13.6027 2.97184 14.1441 3.50418 14.5534 4.13325C14.6506 4.27942 14.6861 4.458 14.6524 4.63023C14.6187 4.80247 14.5185 4.95447 14.3734 5.05325C14.2619 5.12499 14.1327 5.16424 14.0001 5.16659Z",
      fill: "#F09035"
    })
  ])
], -1)
const _hoisted_15 = { class: "flex flex-col gap-1 text-gray-lp-300 text-sm" }
const _hoisted_16 = { class: "font-bold" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_20 = { class: "flex flex-col gap-1 text-sm text-gray-lp-300" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = {
  key: 2,
  class: "flex flex-row items-center gap-1 flex-wrap"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  key: 2,
  class: "text-blue-600 text-xs"
}
const _hoisted_27 = {
  key: 3,
  class: "flex flex-row items-center gap-2 flex-wrap"
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  key: 1,
  class: "rounded-full bg-gray-200 px-2 py-0.5 text-xs text-gray-lp-300"
}
const _hoisted_30 = { class: "flex flex-col gap-1 text-sm text-gray-lp-300" }
const _hoisted_31 = { class: "whitespace-nowrap" }
const _hoisted_32 = { class: "flex flex-col gap-1 text-sm text-black-lp-100" }
const _hoisted_33 = { class: "flex flex-row gap-2 items-center" }
const _hoisted_34 = /*#__PURE__*/_createVNode("span", null, "Diproses bagging", -1)
const _hoisted_35 = { class: "flex flex-row gap-2 items-center" }
const _hoisted_36 = /*#__PURE__*/_createVNode("span", null, "Diproses kargo", -1)
const _hoisted_37 = {
  key: 0,
  class: "flex flex-col min-w-48 font-montserrat gap-y-2"
}
const _hoisted_38 = { class: "flex flex-row items-center justify-between" }
const _hoisted_39 = /*#__PURE__*/_createVNode("span", { class: "font-semibold text-gray-lp-300" }, "Status print", -1)
const _hoisted_40 = { class: "flex flex-col gap-3" }
const _hoisted_41 = { class: "whitespace-nowrap" }
const _hoisted_42 = { class: "hidden" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_PrintStatusIcon = _resolveComponent("PrintStatusIcon")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_Print = _resolveComponent("Print")!
  const _component_WidgetDownloadCargo = _resolveComponent("WidgetDownloadCargo")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.cargoListAvailable)
      ? (_openBlock(), _createBlock(_component_EmptyState, {
          key: 0,
          customMessage: _ctx.$t('Oops.. Belum ada data yang dapat ditampilkan')
        }, null, 8, ["customMessage"]))
      : (_openBlock(), _createBlock(_component_TableV2, {
          key: 1,
          columns: _ctx.columns,
          data: _ctx.cargoList,
          loading: _ctx.isLoading,
          pagination: _ctx.pagination,
          "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
          paginationStyle: "v3",
          totalColumnFreeze: 1,
          isRightFreeze: "",
          onRequest: _ctx.fetchList,
          errorCause: _ctx.errorCause,
          onTryAgain: _ctx.fetchList,
          isDetailAble: true,
          onClick: _ctx.onClickRow,
          groupAction: true,
          groupOptions: _ctx.actionGroupOptions,
          isSpaceTop: false,
          bgHeader: "bg-white border-b border-gray-lp-200",
          paginationV3PaddingVertical: "py-2",
          pinnedSubstractHeight: "300px",
          isPinnedScrollBottom: "",
          customClassPagination: 
        !_ctx.permissionDownloadAwbReceiptSync ? 'absolute w-full bottom-4 right-0 left-0 -mb-4 px-8' : ''
      ,
          isNoPaddingBottom: "",
          isTabList: false,
          paginationWidth: "w-4/5"
        }, {
          number_cargo: _withId(({ item }) => [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                (item.cargoType === 'ship')
                  ? (_openBlock(), _createBlock("img", _hoisted_4))
                  : (item.cargoType === 'truck')
                    ? (_openBlock(), _createBlock("img", _hoisted_5))
                    : (item.cargoType === 'plane')
                      ? (_openBlock(), _createBlock("img", _hoisted_6))
                      : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.ellipsisString(item.cargoNumber, 40)) + " ", 1),
                (item.isDisputeCargo)
                  ? (_openBlock(), _createBlock("div", _hoisted_7, [
                      _withDirectives(_createVNode("div", null, [
                        _createVNode(_component_Icons, {
                          name: "kg-dispute",
                          class: "w-5 text-red-lp-100"
                        })
                      ], 512), [
                        [
                          _directive_tooltip,
                          'Kargo dengan selisih berat',
                          void 0,
                          { bottom: true }
                        ]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (item.cargoCommodityGroupIsDg)
                  ? _withDirectives((_openBlock(), _createBlock("span", _hoisted_8, [
                      _hoisted_9
                    ], 512)), [
                      [
                        _directive_tooltip,
                        'Dangerous Goods',
                        void 0,
                        { bottom: true }
                      ]
                    ])
                  : _createCommentVNode("", true),
                (item.cargoCommodityGroupIsQuarantine)
                  ? _withDirectives((_openBlock(), _createBlock("span", _hoisted_10, [
                      _hoisted_11
                    ], 512)), [
                      [
                        _directive_tooltip,
                        'Karantina',
                        void 0,
                        { bottom: true }
                      ]
                    ])
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_12, [
                (
                _ctx.showRemainingTimePlane(
                  _ctx.CalculateTimeDifference(_ctx.DateNow, item.estimationDepartureDate),
                  item.cargoType,
                  item.departureTime
                )
              )
                  ? (_openBlock(), _createBlock("div", _hoisted_13, [
                      _hoisted_14,
                      _createTextVNode(" " + _toDisplayString(_ctx.CalculateTimeDifference(_ctx.DateNow, item.estimationDepartureDate)), 1)
                    ]))
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode("div", {
                  "data-testid": `new-form-badge-${item.cargoNumber}`,
                  class: "bg-red-lp-600 px-2 rounded-xl text-14px text-red-lp-1500 inline-flex"
                }, " Baru ", 8, ["data-testid"]), [
                  [_vShow, item.isNewForm]
                ])
              ])
            ])
          ]),
          origin_destination: _withId(({ item }) => [
            _createVNode("div", _hoisted_15, [
              _createVNode("div", _hoisted_16, [
                _withDirectives(_createVNode("span", null, [
                  _createTextVNode(_toDisplayString(item.originCityCode), 1)
                ], 512), [
                  [
                    _directive_tooltip,
                    item.originCityName,
                    void 0,
                    { bottom: true }
                  ]
                ]),
                _hoisted_17,
                _withDirectives(_createVNode("span", null, [
                  _createTextVNode(_toDisplayString(item.destinationCityCode), 1)
                ], 512), [
                  [
                    _directive_tooltip,
                    item.destinationCityName,
                    void 0,
                    { bottom: true }
                  ]
                ])
              ]),
              (item.cargoType === 'plane')
                ? (_openBlock(), _createBlock("div", _hoisted_18, [
                    _withDirectives(_createVNode("span", null, [
                      _createTextVNode(_toDisplayString(item.airportOriginCityCode), 1)
                    ], 512), [
                      [
                        _directive_tooltip,
                        item.airportOriginCityName,
                        void 0,
                        { bottom: true }
                      ]
                    ]),
                    _hoisted_19,
                    _withDirectives(_createVNode("span", null, [
                      _createTextVNode(_toDisplayString(item.airportDestinationCityCode), 1)
                    ], 512), [
                      [
                        _directive_tooltip,
                        item.airportDestinationCityName,
                        void 0,
                        { bottom: true }
                      ]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          etd: _withId(({ item }) => [
            _createVNode("div", _hoisted_20, [
              (item.cargoType !== 'plane')
                ? (_openBlock(), _createBlock("div", _hoisted_21, _toDisplayString(_ctx.formatDate(item.departureDate)), 1))
                : (item.estimationDepartureDate)
                  ? (_openBlock(), _createBlock("div", _hoisted_22, _toDisplayString(_ctx.formatDate(item.estimationDepartureDate)), 1))
                  : _createCommentVNode("", true),
              (item.departureDate && item.arrivalDate)
                ? (_openBlock(), _createBlock("div", _hoisted_23, [
                    (item.cargoType === 'plane')
                      ? (_openBlock(), _createBlock("span", _hoisted_24, _toDisplayString(_ctx.formatDate(item.departureDate, "HH:mm")) + " - " + _toDisplayString(_ctx.formatDate(item.arrivalDate, "HH:mm")), 1))
                      : (_openBlock(), _createBlock("span", _hoisted_25, _toDisplayString(_ctx.formatDate(item.departureDate, "HH:mm")), 1)),
                    (_ctx.etdDayOffset(item) > 0)
                      ? (_openBlock(), _createBlock("span", _hoisted_26, _toDisplayString(_ctx.etdDayOffsetLabel(item)), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (item.vehiclePoliceNumber || item.totalTransit > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_27, [
                    (item.vehiclePoliceNumber)
                      ? (_openBlock(), _createBlock("span", _hoisted_28, _toDisplayString(item.vehiclePoliceNumber), 1))
                      : _createCommentVNode("", true),
                    (item.totalTransit > 0)
                      ? (_openBlock(), _createBlock("span", _hoisted_29, _toDisplayString(item.totalTransit) + " transit ", 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          status_print: _withId(({ item }) => [
            _createVNode("div", _hoisted_30, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getPrintStatusItems(item).slice(0, 3), (entry) => {
                return (_openBlock(), _createBlock("div", {
                  key: entry.label,
                  class: "flex flex-row gap-x-1 items-center"
                }, [
                  _createVNode(_component_PrintStatusIcon, {
                    printed: entry.printed
                  }, null, 8, ["printed"]),
                  _createVNode("span", _hoisted_31, _toDisplayString(entry.label), 1)
                ]))
              }), 128)),
              (_ctx.getPrintStatusItems(item).length > 3)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    type: "button",
                    class: "text-blue-lp-700 text-left underline focus:outline-none",
                    onClick: _withModifiers(($event: any) => (_ctx.openPrintPopover($event, item)), ["stop"])
                  }, " Lihat lainnya ", 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          selisih_berat: _withId(({ item }) => [
            _createVNode("div", _hoisted_32, [
              _createVNode("div", _hoisted_33, [
                _createVNode(_component_PrintStatusIcon, {
                  printed: item.isDisputeFromBagging
                }, null, 8, ["printed"]),
                _hoisted_34
              ]),
              _createVNode("div", _hoisted_35, [
                _createVNode(_component_PrintStatusIcon, {
                  printed: item.isDisputeFromCargo
                }, null, 8, ["printed"]),
                _hoisted_36
              ])
            ])
          ]),
          _: 1
        }, 8, ["columns", "data", "loading", "pagination", "onRequest", "errorCause", "onTryAgain", "onClick", "groupOptions", "customClassPagination"])),
    _createVNode(_component_OverlayPanel, {
      id: "printPopoverIncomingOutgoing",
      ref: "printPopover",
      class: "print-status-popover"
    }, {
      default: _withId(() => [
        (_ctx.printPopoverItem)
          ? (_openBlock(), _createBlock("div", _hoisted_37, [
              _createVNode("div", _hoisted_38, [
                _hoisted_39,
                _createVNode("button", {
                  type: "button",
                  class: "rounded hover:bg-gray-lp-200 text-gray-lp-600 focus:outline-none",
                  "aria-label": "Tutup",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closePrintPopover && _ctx.closePrintPopover(...args)))
                }, [
                  _createVNode(_component_Icons, {
                    name: "close",
                    class: "w-4 h-4"
                  })
                ])
              ]),
              _createVNode("div", _hoisted_40, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getPrintStatusItems(_ctx.printPopoverItem), (entry) => {
                  return (_openBlock(), _createBlock("div", {
                    key: entry.label,
                    class: "flex flex-row gap-2 items-center text-sm"
                  }, [
                    _createVNode(_component_PrintStatusIcon, {
                      printed: entry.printed
                    }, null, 8, ["printed"]),
                    _createVNode("span", _hoisted_41, _toDisplayString(entry.label), 1)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512),
    _createVNode("div", _hoisted_42, [
      _createVNode(_component_Print, { ref: "print" }, null, 512)
    ]),
    (!_ctx.permissionDownloadAwbReceiptSync)
      ? (_openBlock(), _createBlock(_component_WidgetDownloadCargo, { key: 2 }))
      : _createCommentVNode("", true)
  ]))
})